// extracted by mini-css-extract-plugin
module.exports = {"InformationalBox":"InformationalBox_InformationalBox__3hDgY","InformationalBox__content":"InformationalBox_InformationalBox__content__3Hs6Y"};